import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const PodcastDetailPageContainer = styled.div`
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
`;

export const PodcastImage = styled.img`
  width: 100%;
  max-width: 260px;
  aspect-ratio: 1/1;
  object-fit: cover;

  @media (max-width: 900px) {
    max-width: 240px;
  }

  @media (max-width: 640px) {
    align-self: center;
  }

  @media (max-width: 400px) {
    max-width: 156px;
  }
`;

export const PodcastDetailWrapper = styled.div`
  display: flex;
  gap: 36px;
  margin-top: 20px;
  align-items: flex-start;

  @media (max-width: 800px) {
    gap: 17px;
  }

  @media ${breakpoints.xs} {
    flex-direction: column;
  }
`;

export const ReleasesListWrapper = styled.div`
  margin: 64px 0;
`;

export const PodcastDetailWrapperSkeleton = styled.span`
  margin-top: 30px;
  margin-bottom: 64px;
  height: 100%;
  max-height: 260px;

  @media ${breakpoints.md} {
    max-height: 240px;
    margin-bottom: 48px;
  }

  @media ${breakpoints.xs} {
    max-height: 158px;
    max-width: 158px;
    margin-bottom: 24px;
  }
`;

export const ReleasesListWrapperSkeleton = styled.span`
  height: 100%;
  max-height: 88px;
  margin-bottom: 16px;

  & span:nth-child(2) {
    margin-bottom: 40px;
  }
`;

export const SortButton = styled.button`
  display: flex;
  padding: 0;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  width: fit-content;
  gap: 8px;
`;

export const ArrowContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.5s ease;
  transform: ${(props) =>
    props.sortOrder !== "newest" ? "rotate(180deg)" : "rotate(0)"};
`;
